(function ($, Drupal) {
  Drupal.behaviors.blockBanner = {
    attach: function (context) {
      once('blockBanner', '.block--banner', context).forEach(function (block) {
        const background = block.querySelector('.block--banner__background');
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: `#${block.id}`,
            start: 'top bottom',
            end: 'bottom',
            scrub: 1,
          },
        });

        tl.fromTo(
          background,
          { backgroundPositionY: '0%' },
          { backgroundPositionY: '100%' },
        );
      });
    },
  };
}(jQuery, Drupal));
